
<template>
  <!-- 打款账户审核状态 -->
  <div
    v-if="accountCenterInfo.status !== 'PASSED'"
    style="background-color: #f4f7fa;padding-top: 24px; padding-bottom:5px;"
  >
    <div
      v-if="accountCenterInfo.status === 'PENDING'"
      class="topbox"
    >{{ $t('components.webList.accountChecking') }}</div>
    <div v-else-if="accountCenterInfo.status === 'FAILED'" class="topbox">
      <i class="pp-icon pp-icon-information-circled icontop" />
      {{ $t('components.webList.accountNotAllow') }}
      <pp-button
        type="primary"
        class="btn"
        size="spec"
        @click="updateuser"
      >{{ $t('components.webList.addAgain') }}</pp-button>
    </div>
    <div v-else-if="accountCenterInfo.status === 'EMPTY'" class="topbox">
      {{ $t('components.webList.accountNoAdd') }}
      <pp-button
        type="primary"
        class="btn"
        size="spec"
        @click="updateuser"
      >{{ $t('components.webList.addNow') }}</pp-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {
  mapGetters: userMapGetters
} = createNamespacedHelpers('user')

import { getAccountList } from '@/api/modules/cashAccount'

export default {
  name: 'AccountCheckStatus',
  data() {
    return {
      failedAccount: 0
    }
  },
  created() {
    this.fetchAccountList()
  },
  computed: {
    ...userMapGetters(['accountCenterInfo'])
  },

  methods: {
    // 账户列表
    async fetchAccountList() {
      const list = await getAccountList({
        clientId: this.accountCenterInfo.clientId
      })

      this.accountList = list || []
      // 审核失败的账户数量
      this.failedAccount = this.getPassedCount(list, 'FAILED')
    },
    getPassedCount(list, status) {
      const _list = list.filter(item => item.status === status)
      return _list ? _list.length : 0
    },

    jump() {
      this.$jump('/aq/cashAccount')
    },
    updateuser() {
      this.$jump({ path: '/aq/accountCenter' })
    }
  }
}
</script>

<style lang="scss" scoped>
.topbox {
	margin: 0 auto 0 auto;
	height: 80px;
	line-height: 80px;
	color: #000;
	font-size: 14px;
	padding: 0 48px;
	width: 1190px;
	box-shadow: 0px 3px 10px 0px #f5f5f5;
	background-color: #ffffff;
	.icontop {
		line-height: 80px;
		color: #ff4949;
		font-size: 20px;
		margin-right: 12px;
	}
	.btn {
		height: 35px;
		padding: 6px 24px;
		float: right;
		margin-top: 24px;
		background: #ffffff;
		border: 1px solid #e9e9e9;
		border-radius: 16px;
		font-family: PingFangSC-Regular;
		font-size: 16px;
		color: #1fa0e8;
		letter-spacing: 0;
		font-weight: bold;
	}
}
</style>
